export default "__VITE_ASSET__c8b09cc7__"